module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAAXNSR0IArs4c6QAAAEJQTFRFAAAAIGDvKmrvLWnvLGjrKWnsKmjsLGjtLGjrK2jsK2nsLGnsLGnrKmjrK2nrK2jrK2jsK2nsLGnsLGjsK2jsLGnsZM8M6gAAABR0Uk5TABAwP0BQYH+AkKCvwMHP0N/g7/COmi+5AAAAg0lEQVQoz63S0Q7CIAyF4VMs4iqrU3be/1W90CkgSzTxvyJ8CSUEIKRHijbjViflqqqqGnkLDTA/F0e6DAET3521Akz5Fb2GqsyvQGQHLr4D5F9AkoCEJOkg0oUUZ+yPMjrptM8ZRnLbb4fbutr4VvP861u1UJbDoKVUn6HJgHAaFHAHC4MNGhhb75kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/down-pdf.png
// module id = nzcl
// module chunks = 0